// extracted by mini-css-extract-plugin
export default {"root":"T35xEvXybvMqe9VeC4rh","contentWrapper":"hrGQ5_OV5lErOOUNbzNz","leftSection":"DGKicptgcO7E9_7R0iAe","rightSection":"nkfczTC0lwaGAZsr1xu4","triangle":"PEUTBlh7PIsM_GmEJoHr"};